












import { defineComponent } from '@nuxtjs/composition-api'
import { useBreakpoint } from '~/composables/ui/useBreakpoint'
import { useViewedProducts } from '~/composables/product/useProductDetail'
import { useAuth } from '~/composables/useAuth'

export default defineComponent({
  name: 'ProductBlockViewedProducts',

  setup() {
    const { isMobileAndTablet } = useBreakpoint()
    const { authed } = useAuth()
    const { getViewedProducts, viewedProducts } = useViewedProducts()

    if (authed.value && process.client) {
      getViewedProducts()
    }

    return {
      isMobileAndTablet,
      viewedProducts,
    }
  },
})
